import { render, staticRenderFns } from "./TheCertifications.vue?vue&type=template&id=705451d6&scoped=true&"
import script from "./TheCertifications.vue?vue&type=script&lang=js&"
export * from "./TheCertifications.vue?vue&type=script&lang=js&"
import style0 from "./TheCertifications.vue?vue&type=style&index=0&id=705451d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705451d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
